'use client'

import { createContext, useContext, useState } from 'react'

const AppOpenModalContext = createContext<{
  hidden: boolean
  setHidden: (hidden: boolean) => void
}>({ hidden: false, setHidden: () => {} })

export const AppOpenModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [hidden, setHidden] = useState(false)

  return (
    <AppOpenModalContext.Provider value={{ hidden, setHidden }}>
      {children}
    </AppOpenModalContext.Provider>
  )
}

export const useAppOpenModal = () => useContext(AppOpenModalContext)
